module.exports = __webpack_public_path__ + "img/dentoholic_logo.1629a27b.svg";